import moment from 'moment';
import { cast } from 'mobx-state-tree';
import { timetable_itemQuery, timetable_itemQueryVariables, TIMETABLE_ITEMS } from '@app-types/graphql-types';
import { TimelineItemTypeType } from '@app-types/timetable';
import { ApolloQueryResult } from '@apollo/client';
import { apolloClient } from '@lib/apollo';
import { TimetableModelType } from '../../Timetable';
import { TimelineItemModelType } from '../../TimelineItem';

export const loadTimelineItemsFromDB = (self: Partial<TimetableModelType>) => {
  return function* loadTimelineItemsFromDBAsync() {
    if (self.week) {
      self.loadingTimelineItems = true;

      const startOfWeek = moment().year(self.week.year()).week(self.week.week()).startOf('isoWeek');
      const endOfWeek = moment().year(self.week.year()).week(self.week.week()).endOf('isoWeek');

      // Fetch timeline items
      const timetableItems: ApolloQueryResult<timetable_itemQuery> = yield apolloClient.query<
        timetable_itemQuery,
        timetable_itemQueryVariables
      >({
        query: TIMETABLE_ITEMS,
        variables: {
          where: {
            _and: [
              {
                startTime: {
                  _gte: startOfWeek,
                },
              },
              {
                endTime: {
                  _lte: endOfWeek,
                },
              },
            ],
          },
        },
        fetchPolicy: 'no-cache',
      });

      // Get intervals to spare them
      const existingIntervals = self.timelineItems?.filter(
        (timelineItem) => timelineItem.itemType === TimelineItemTypeType.interval,
      );

      // Build timeline items
      if (timetableItems?.data?.timetable_item.length > 0) {
        const timeLineItems: TimelineItemModelType[] = timetableItems.data.timetable_item.map((timetableItem) => ({
          id: timetableItem.id,
          groupID: `lecture/${timetableItem.batchClassId}`,
          title:
            (timetableItem.batch_subject_configuration
              ? timetableItem.batch_subject_configuration.subject?.code
              : timetableItem.batch_subject_extra_slot?.name) || '',
          startTime: moment(timetableItem.startTime),
          endTime: moment(timetableItem.endTime),
          duration: moment.duration(moment(timetableItem.endTime).diff(moment(timetableItem.startTime))).asHours(),
          color:
            (timetableItem.batch_subject_configuration
              ? timetableItem.batch_subject_configuration.subject?.color
              : timetableItem.batch_subject_extra_slot?.batch_subject_configuration?.subject?.color) || '',
          elementID: timetableItem.batch_subject_configuration
            ? timetableItem.batch_subject_configuration.id
            : timetableItem.batch_subject_extra_slot?.id,
          batchClassID: `lecture/${timetableItem.batchClassId}`,
          itemType: timetableItem.batch_subject_configuration
            ? TimelineItemTypeType.subject
            : TimelineItemTypeType.extra,
          lecturerID: timetableItem.userId || undefined,
          locationID: timetableItem.locationId || undefined,
          subjectName: timetableItem.batch_subject_configuration
            ? timetableItem.batch_subject_configuration.subject?.name
            : timetableItem.batch_subject_extra_slot?.batch_subject_configuration?.subject?.name,
          published: timetableItem.published || false,
          batchName: timetableItem.batch_class.batch.name || undefined,
          batchClassName: timetableItem.batch_class.name || undefined,
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          removeItem: () => {},
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          moveItem: () => {},
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          setEndTime: () => {},
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          setStartTime: () => {},
          dbId: timetableItem.id,
        }));

        self.timelineItems = cast([...(existingIntervals as TimelineItemModelType[]), ...timeLineItems]);
      } else {
        self.timelineItems = cast(existingIntervals);
      }

      self.loadingTimelineItems = false;
    }
  };
};
